import { render, staticRenderFns } from "./GBplatform.vue?vue&type=template&id=161903e4&"
import script from "./GBplatform.vue?vue&type=script&lang=js&"
export * from "./GBplatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports